// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../../actions';

// Forms
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { TextFieldAdapter } from '../TextFieldAdapter';
import { TextFieldAdapterRT } from '../TextFieldAdapterRT';

// Custom
import { ErrorMessage } from "../ErrorMessage";
import { ActionButton } from '../Buttons/ActionButton';
import { CancelButton } from '../Buttons/CancelButton';
import { FormIcon } from '../FormIcon';
import AuthFormFooter from 'components/Form/AuthFormFooter';
import TextButton from 'components/Button/TextButton';


// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../validation';
import { constants } from '../../../constants';

const PasswordResetStep = props => {
    const { handleClose, errorData, errors, handleChooseAuthDialog, stepperControls, resetErrors } = props;
    const { reverseStepper, advanceStepper } = stepperControls;

    const handlePasswordReset = (values) => {
        props.forgotPassword(values.email)
        .then((res) => {
            props.notifyUser({
                visible: true,
                message: `Your password reset link has been sent to ${values.email}.`,
                textColor: 'white'
            });
            props.handleClose();
        })
        .catch(console.log);
    }

    return (
        <div style={ styles.containerStyles } label="Password Reset">
            <h3>RESET YOUR PASSWORD</h3>
            <Form
                onSubmit={handlePasswordReset}
                render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => (
                    <form id="resetForm" onSubmit={handleSubmit} style={{display: 'flex', flexFlow: 'column nowrap'}}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <label style={{ display: 'none' }}>Email</label>
                            <Field
                                name="email"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="Email"
                                validate={isEmail}
                                icon="envelope"
                            />
                        </div>
                        
                        { errors && <ErrorMessage errors={errors} />}
                        
                            <ActionButton 
                                options={{
                                    label: 'Send Reset Link',
                                    form: 'resetForm',
                                    action: (event)=>{
                                        handleSubmit(event);
                                    },
                                    // isNextButton: false,
                                    disabled: pristine || invalid
                                }}
                                advanceStepper={advanceStepper}
                            />
                            
                            <AuthFormFooter>
                                <TextButton onClick={
                                    (event) => {
                                        handleChooseAuthDialog('login');
                                    }}
                                >
                                    <h2 style={{ display: 'flex', color: '#379DA8', fontSize: 14,}}>
                                        Back to Log in
                                    </h2>
                                </TextButton>
                            </AuthFormFooter>
                    </form>
                )}
            />
        </div>);
}

export default connect(null, actions)(PasswordResetStep);

const styles = {
    containerStyles: {
        fontSize: constants.text.baseFontStyles.fontSize
    },
}


// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/PasswordResetStep.jsx